let accordionToggler = $('.hair__faq-list__wrapper .btn-bar .accordion_toggler')

accordionToggler.on('click', function (e){
    e.preventDefault();
    $(this).toggleClass('opened');
    let txtBlock = $(this).closest('.hair__faq-list__wrapper').find('.hair__faq-list').toggleClass('full-review');

    if ( !$(txtBlock).hasClass("full-review") ) {
        txtBlock.animate({ 'max-height': 370 });
    }  else {
        txtBlock.animate({'max-height': txtBlock[0].scrollHeight + "px"});
    }
})